import {FC, useCallback} from "react";
import {useSidebar} from "@hooks/selectors/panel.selectors";
import {sidebarActions} from "@store/sidebarStore";
import { useAppDispatch } from "@services/hooks/helperHooks";
import {OverlayTrigger, Button, Tooltip} from "react-bootstrap";
import {OverlayInjectedProps} from "react-bootstrap/Overlay";

const renderTooltip = (props: OverlayInjectedProps) => (
    <Tooltip {...props} style={{ ...props.style, position: 'fixed' }} id="button-tooltip">
        Toggle Navigation
    </Tooltip>
);

const ToggleButton: FC = () => {

    const dispatch = useAppDispatch();
    const {
        isOnRight,
        isFluid
    } = useSidebar();
    const sidebar_toggle = useCallback(() => dispatch(sidebarActions.toggleSidebar()), [dispatch]);

    const handleClick = () => {
        document
            .getElementsByTagName('html')[0]
            .classList.toggle('navbar-vertical-collapsed');
        sidebar_toggle();
    };

    return (
        <OverlayTrigger
            placement={
                isFluid ? (isOnRight ? 'bottom' : 'right') : isOnRight ? 'bottom' : 'left'
            }
            overlay={renderTooltip}
        >
            <div className="toggle-icon-wrapper">
                <Button
                    variant="link"
                    className="navbar-toggler-humburger-icon navbar-vertical-toggle"
                    id="toggleNavigationTooltip"
                    onClick={handleClick}
                >
          <span className="navbar-toggle-icon">
            <span className="toggle-line" />
          </span>
                </Button>
            </div>
        </OverlayTrigger>
    );
}

export default ToggleButton;